import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import css from '../../../../css/css-variables.json';
import InitialsCircle from '../InitialsCircle';
import { getInitials } from '../../utils/profileHelpers';
import { PATH_PROFILE, ORG_PATHS } from '../../constants';

const { string, func } = PropTypes;

const StyledLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  & > * {
    flex: 0 0 auto;
  }

  text-decoration: none;

  &.active {
    color: ${css.colors.ActiveMenuItem};
  }

  & > *:first-child {
    margin-left: 0;
  }
`;

const Label = styled.div`
  flex: 0 1 auto;

  text-decoration: underline;
  a.active > & {
    text-decoration: none;
  }
`;

export const OrgProfileLink = ({
  selectedProfileId,
  organizationId,
  organizationName,
  initials,
  initialsColor,
  onClick
}) => {
  const className = selectedProfileId === organizationId ? 'active' : '';

  return (
    <StyledLink
      className={className}
      to={ORG_PATHS.PROFILE.replace(':organizationId', organizationId)}
      onClick={onClick}
    >
      <InitialsCircle
        small
        centered
        initials={initials ?? getInitials(organizationName)}
        initialsColor={initialsColor}
      />
      <Label>
        {organizationName}
      </Label>
    </StyledLink>
  );
};

OrgProfileLink.propTypes = {
  selectedProfileId: string,
  organizationId: string.isRequired,
  organizationName: string.isRequired,
  initials: string,
  initialsColor: string,
  onClick: func
};


export const UserProfileLink = ({
  userId,
  selectedProfileId,
  firstName,
  initials,
  initialsColor,
  onClick
}) => {
  const className = userId === selectedProfileId ? 'active' : '';

  return (
    <StyledLink className={className} to={PATH_PROFILE} onClick={onClick}>
      <InitialsCircle
        small
        centered
        initials={initials ?? getInitials(firstName)}
        initialsColor={initialsColor}
      />
      <Label>
        {firstName}&apos;s Profile
      </Label>
    </StyledLink>
  );
};

UserProfileLink.propTypes = {
  userId: string.isRequired,
  selectedProfileId: string,
  firstName: string.isRequired,
  initials: string,
  initialsColor: string,
  onClick: func
};
